import { render } from "./GuidedCreationInclusions.vue?vue&type=template&id=7a2b4437&scoped=true"
import script from "./GuidedCreationInclusions.vue?vue&type=script&lang=js"
export * from "./GuidedCreationInclusions.vue?vue&type=script&lang=js"

import "./GuidedCreationInclusions.vue?vue&type=style&index=0&id=7a2b4437&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a2b4437"]])

export default __exports__